export type MigrationIcons = Array<{
	componentName: string;
	legacyIconName: string;
	newIconName: string;
}>;

/**
 * Find all migration icons in the source code.
 */
export const findMigrationIcons = (sourceCode: string): MigrationIcons => {
	const migrationIconRegex =
		/import\s+(\w+)\s+from\s+'@atlaskit\/icon\/(?:core|utility)\/migration\/([^']+)';/g;

	const migrationIconMatches = [...sourceCode.matchAll(migrationIconRegex)];

	return migrationIconMatches.map((match) => {
		const componentName = match[1];
		const [newIconName, legacyIconName] = match[2].split('--');
		return {
			componentName,
			legacyIconName: legacyIconName || newIconName,
			newIconName,
		};
	});
};
